import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';
import { Footer } from 'routes/secondary-market-batch/footer';
import { Grid } from 'routes/secondary-market-batch/grid/components';
import { WithGridApiContext } from 'routes/secondary-market-batch/grid/hooks/use-grid-api-context';
import { Header } from 'routes/secondary-market-batch/header';

const SecondaryMarketBatchQuotesPage = () => {
  return (
    <WithGridApiContext>
      <div className="d-flex flex-column h-100">
        <Header />
        <Grid />
        <Footer />
      </div>
    </WithGridApiContext>
  );
};

export default function SecondaryMarketBatchWorkspace() {
  return (
    <QuoteWorkspaceProvider value="secondaryMarketQuotes">
      <SecondaryMarketBatchQuotesPage />
    </QuoteWorkspaceProvider>
  );
}
